export const getLongId = (prefix: string, id: string | number): string => {
  const stringId = String(id);

  return stringId.startsWith(prefix) ? stringId : `${prefix}${id}`;
};
